// utils/pdfHelpers.ts

// Convierte Blob a Base64
export const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      if (typeof reader.result === 'string') resolve(reader.result);
      else reject(new Error('Error convirtiendo a base64'));
    };
    reader.onerror = () => reject(new Error('Error leyendo blob'));
  });

// Convierte Base64 a Blob tipo PDF
export function base64ToPdfBlob(base64: string): Blob {
  if (base64.startsWith("data:application/octet-stream")) {
    base64 = base64.replace("data:application/octet-stream", "data:application/pdf");
  }

  const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;
  const bin = atob(base64Data);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);

  return new Blob([arr], { type: "application/pdf" });
}


// Opciones optimizadas para html2pdf
export const defaultPdfOptions = {
  margin: [10, 12, 12, 12], // mm → más control real
  filename: 'documento.pdf',

  image: { type: 'jpeg', quality: 0.95 },

  html2canvas: {
    scale: 2,
    useCORS: true,
    scrollY: 0,
    windowWidth: 1024,
  },

  jsPDF: {
    unit: 'mm',
    format: 'a4',
    orientation: 'portrait',
  },

  pagebreak: {
    mode: ['avoid-all', 'css', 'legacy'],
  },
};


/** Construye FormData para enviar contrato o factura */
export function construirFormData(
  tipo: 'contrato' | 'factura',
  blob: Blob,
  formData1: any,
  payment_intent_id: string,
  cantidadEuros?: number,
  filename?: string
): FormData {
  const datos = new FormData();

  // 🔥 AÑADIR ESTO
  datos.append('tipo', tipo);

  const fileNameToUse = filename ?? `${tipo}-${Date.now()}.pdf`;
  datos.append('file', blob, fileNameToUse);

  datos.append('payment_intent_id', payment_intent_id);
  datos.append('transactionId', payment_intent_id);

  if (formData1?.profesional_id) datos.append('profesional_id', String(formData1.profesional_id));
  if (formData1?.usuario_id) datos.append('usuario_id', String(formData1.usuario_id));
  if (formData1?.perfil_profesional_id)
    datos.append('perfil_profesional_id', String(formData1.perfil_profesional_id));
  if (formData1?.dniNie) datos.append('dniNie', String(formData1.dniNie));
  if (formData1?.cif) datos.append('cif', String(formData1.cif));

  if (tipo === 'factura' && cantidadEuros !== undefined) {
    datos.append('cantidad', String(cantidadEuros));
    datos.append('concepto', 'Suscripción');
    datos.append('metodo_pago', 'card');
    datos.append("piId", payment_intent_id);
    datos.append("total", String(cantidadEuros));
  }

  return datos;
}

